import React from 'react';
import { usePrefs } from 'wsm-common-data';

const NavIcon = ({ labels, labelAlias }) => {
	const { childListIconStyle, showChildIcons, childListIconPosition } =
		usePrefs();

	const positionClasses = {
		before: 'mr-2',
		after: 'ml-2'
	};

	const dropdownIconClasses = [
		'ddc-icon',
		`ddc-icon-${childListIconStyle}`,
		'ddc-nav-icon',
		positionClasses[childListIconPosition]
	].join(' ');

	const getInnerContent = () => {
		if (showChildIcons === 'true') {
			if (childListIconPosition === 'before') {
				return (
					<>
						<i className={dropdownIconClasses} />
						{labels.getHTML(labelAlias || '')}
					</>
				);
			} else if (childListIconPosition === 'after') {
				return (
					<>
						{labels.getHTML(labelAlias || '')}
						<i className={dropdownIconClasses} />
					</>
				);
			}
		}
		return labels.getHTML(labelAlias || '');
	};

	return getInnerContent();
};

export default NavIcon;
